"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboDefaultPostingTime = void 0;
const constants_1 = require("@daytrip/constants");
const LONGEST_WAITING_FOR_BETTER_COMBO_DAYS = 21;
const PERSONAL_COMBO_EXPIRATION_DELAY_TRERESHOLDS = {
    best: 100,
    mediocre: 35,
    worst: 28,
};
const CLEAN_COMBO_EXPIRATION_TRERESHOLD_HOURS = {
    best: 100,
    mediocre: 28,
    worst: LONGEST_WAITING_FOR_BETTER_COMBO_DAYS,
};
const getComboDefaultPostingTime = ({ isPersonal, originCountryId, comboQuality, departureAtUtc, }) => {
    const nowMs = new Date().getTime();
    const departureAtMs = new Date(departureAtUtc).getTime();
    const daysToDeparture = (departureAtMs - nowMs) / constants_1.DAY_IN_MILLISECONDS;
    const tresholds = isPersonal
        ? PERSONAL_COMBO_EXPIRATION_DELAY_TRERESHOLDS
        : CLEAN_COMBO_EXPIRATION_TRERESHOLD_HOURS;
    const dafaultDaysToWait = tresholds[comboQuality];
    const addedDays = originCountryId === constants_1.ITALY_COUNTRY_ID ? 7 : 0;
    const daysToWait = dafaultDaysToWait + addedDays;
    // Enable after introducing combos in CT
    const COMBOS_IN_CT_ENABLED = false;
    // Case when combo might be posted, but it should be postponed to allow claiming
    // If departure is soon, do not wait for users to claim
    if (COMBOS_IN_CT_ENABLED && daysToDeparture <= daysToWait) {
        return Math.max(LONGEST_WAITING_FOR_BETTER_COMBO_DAYS, daysToDeparture - 1);
    }
    return daysToWait;
};
exports.getComboDefaultPostingTime = getComboDefaultPostingTime;
//# sourceMappingURL=getComboDefaultPostingTime.js.map